import { getEventListeners } from '../dataLayer/openPixState.tsx';
import { log } from '../log/OpenPixLogger.tsx';

export const notifyListeners = (message: any) => {
  const listeners = getEventListeners();

  for (const listener of listeners) {
    if (typeof listener === 'function') {
      try {
        listener(message);
      } catch (err) {
        log('listener error: ', err);
      }
    }
  }
};
